<script lang="ts">
  import type { UserLessonStore } from 'shared/src/user/userLessons/user.lesson.store';
  import { autorun } from 'mobx';
  import { onDestroy } from 'svelte';
  import Button from '$lib/components/Button.svelte';
  import type { UserCheckpointStore } from 'shared/src/user/userLessons/user.checkpoint.store';

  export let lesson: UserLessonStore | UserCheckpointStore;

  let nextLessonRoute: string;
  let nextLessonString = 'Lessons';
  const destroy = autorun(() => {
    const nextLessonId = lesson.nextAvailableIncompleteLessonOrNextLesson?.id;
    nextLessonRoute = lesson.nextAvailableIncompleteLessonOrNextLesson?.id || '';
    nextLessonString = nextLessonId ? 'Next Lesson' : 'Lessons';
  });
  onDestroy(destroy);
</script>

<a href="/app/lessons/{nextLessonRoute}">
  <Button>{nextLessonString}</Button>
</a>
